// src/components/SPanel/Home/HomeTile.jsx
//
// Cadrul unui widget: cardul (link, buton sau simplu bloc), antetul cu iconiță
// și titlu, cifrele care cresc. Cardul e „container” CSS: mărimile din interior
// se potrivesc pe pătratul widget-ului (vezi _studentHome.scss). Liquid Glass ca
// elementele din components/UI: marginea de gheață și, la cel apăsabil, lumina
// care pornește din punctul atins (pressPoint).

import React from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

import { useCountUp } from "./homeHooks";
import { ButtonUI, TagUI } from "../../UI";
import { pressPoint } from "../../UI/glass";

export function Icon({ src }) {
   return <ReactSVG src={src} className="wd-icon react-icon" aria-hidden="true" />;
}

export function CountUp({ value, duration }) {
   return <>{useCountUp(value, duration)}</>;
}

export function Tile({ id, size, to, onClick, tone, className = "", label, children }) {
   const cls =
      `hw__card wd wd--${id} wd--s-${size}` +
      (tone ? ` wd--${tone}` : "") +
      (className ? ` ${className}` : "");
   if (to) {
      return (
         <Link to={to} className={cls} aria-label={label} onPointerDown={pressPoint}>
            {children}
         </Link>
      );
   }
   if (onClick) {
      return (
         <button type="button" className={cls} onClick={onClick} aria-label={label} onPointerDown={pressPoint}>
            {children}
         </button>
      );
   }
   return (
      <section className={cls} aria-label={label}>
         {children}
      </section>
   );
}

// antetul ca al panourilor din admin (CardUI): titlul fără iconiță, cu 10px
// înăuntru, „→” în dreapta. icon rămâne în semnătură pentru apelurile vechi.
// eslint-disable-next-line no-unused-vars
export function Head({ icon, title, extra, action }) {
   return (
      <div className="wd__head">
         <h3 className="wd__title">{title}</h3>
         {extra}
         {action && (
            <ButtonUI as={Link} to={action.to} size="sm" className="wd__action">
               {action.label}
               <span aria-hidden="true">→</span>
            </ButtonUI>
         )}
      </div>
   );
}

// starea unui pas / examen (TagUI): ok, bad, live, none; onCard: stă direct pe
// card (black-s), deci „none” ia fundalul paginii ca să se vadă
const STATUS_TONE = { ok: "success", bad: "danger", live: "accent" };

export function StatusTag({ tone, onCard = false, className, children }) {
   return (
      <TagUI tone={STATUS_TONE[tone] || (onCard ? "page" : "neutral")} size="md" className={className}>
         {children}
      </TagUI>
   );
}

export function Skeleton() {
   return <div className="wd-skeleton" aria-label="Se încarcă" />;
}
